// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"36f545677a396278f537","551":"e6f8dc38b2536cd4fa8a"}[chunkId] + ".css";
};